import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  Back,
  Customer,
  HoldCart,
  PosScreen,
  Transaction,
  WhiteCart,
  WhiteCustomer,
  WhitePos,
  WhiteTransaction,
} from "../images";
import Modal from "../components/Reuseable/Modal";
import { useBoolean } from "../components/PosScreen/globalState/ItemFlag";

type Props = {
  screen?: any;
};
const navigation = [
  {
    id: 0,
    name: "Dashboard",
    navigation: "/",
  },
  {
    id: 1,
    name: "Category",
    navigation: "/category",
  },
  {
    id: 2,
    name: "Invoice",
    navigation: "/invoice",
  },
  {
    id: 3,
    name: "Product",
    navigation: "/product",
  },
  {
    id: 4,
    name: "Stock",
    navigation: "/stock",
  },
  {
    id: 5,
    name: "Sales Ledger",
    navigation: "/sales-ledger",
  },
  {
    id: 6,
    name: "Customers",
    navigation: "/customer",
  },
  // {
  //   id: 7,
  //   name: "Test Form",
  //   navigation: "/test_form",
  // },
];
const SidebarLayout = (props: Props) => {
  const initialPath = window.location.pathname;
  const [clickedIndex, setClickedIndex] = useState(initialPath);
  const [openClearScreen, setOpenClearScreen] = useState(false);
  const navigate = useNavigate();
  const { isTrue } = useBoolean();
  useEffect(() => {
    setClickedIndex(window.location.pathname);
  }, [window.location.pathname]);
  const isActive = (navPath: string) => {
    if (navPath === "/") {
      return clickedIndex === "/";
    }
    return clickedIndex.startsWith(navPath);
  };
  const handleNavigation = (e: any) => {
    if (isTrue) {
      setOpenClearScreen(true);
    } else {
      navigate(e.navigation)
    }
  };
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handlePopState = () => {
      if (isTrue) {
        setOpenClearScreen(true);
        window.history.pushState(null, "", window.location.href);
      }
    };
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isTrue) {
        e.stopPropagation()
        e.preventDefault()
      }
    };
    window.addEventListener("popstate", handlePopState);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isTrue]);


  return (
    <>
      <div className="font-sans w-[23%] h-[95vh] bg-white border-r border-[#DEE2E6]">
        <div className="w-full flex flex-col flex-[20%] p-10">
          <p className="p-2 text-lg border border-[#635454] text-center rounded">
            Jewellery POS
          </p>
        </div>

        <div className="w-full flex flex-col flex-[80%]">
          {navigation.map((nav: any) => (
            <div
              key={nav.id}
              onClick={() => handleNavigation(nav)}
              className={
                isActive(nav.navigation)
                  ? "w-full mb-0.5 text-white p-1.5 bg-primary cursor-pointer"
                  : "mb-0.5 p-1.5 w-full cursor-pointer"
              }
            >
              <div className="w-full ml-4 text-left">
                {nav.name}
              </div>
            </div>
          ))}
        </div>
      </div>

      <Modal
        isOpen={openClearScreen}
        setIsOpen={setOpenClearScreen}
        title="Alert"
      >
        <div className="w-full flex flex-col justify-center items-center p-4 font-medium">
          <p>Please clear your Invoice first !!!</p>
        </div>
      </Modal>
    </>
  );
};


export default SidebarLayout;
